import React, {Component} from 'react';

export default class SelectedMember extends Component {
    constructor(){
        super();
    }

    render(){
        const {name, title, info, imgPath, logoPath} = this.props;
        const style = {
            backgroundImage: `url(${imgPath})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        };

        return(
            <div className='selected-member'>
                <div className='selected-member-filter' style={style}></div>
                <div className='selected-member-text'>
                    <h2>{name}</h2>
                    <h3>{title}</h3>
                    <p className='selected-member-info'>
                        {info}
                    </p>
                    <img src={logoPath} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/meet_the_team/selected_member.js